import React from 'react'
import "./CommunicationItem.scss"
import apiRequest from '../../lib/apiRequest'
import {whatsappIcon,PhoneIcon,EmailIcon, WhatsappIcon} from '../../lib/myIcons'




// const whatsapp=(
// <svg 
//     xmlns="http://www.w3.org/2000/svg" 
//     width="32" 
//     height="32" 
//     viewBox="0 0 510 512.459" 
//     fill="#13d029ff"
// >
//   <path d="M435.689 74.468C387.754 26.471 324 .025 256.071 0 116.098 0 2.18 113.906 2.131 253.916c-.024 44.758 11.677 88.445 33.898 126.946L0 512.459l134.617-35.311c37.087 20.238 78.85 30.891 121.345 30.903h.109c139.949 0 253.88-113.917 253.928-253.928.024-67.855-26.361-131.645-74.31-179.643v-.012zm-179.618 390.7h-.085c-37.868-.011-75.016-10.192-107.428-29.417l-7.707-4.577-79.886 20.953 21.32-77.889-5.017-7.987c-21.125-33.605-32.29-72.447-32.266-112.322.049-116.366 94.729-211.046 211.155-211.046 56.373.025 109.364 22.003 149.214 61.903 39.853 39.888 61.781 92.927 61.757 149.313-.05 116.377-94.728 211.058-211.057 211.058v.011zm115.768-158.067c-6.344-3.178-37.537-18.52-43.358-20.639-5.82-2.119-10.044-3.177-14.27 3.178-4.225 6.357-16.388 20.651-20.09 24.875-3.702 4.238-7.403 4.762-13.747 1.583-6.343-3.178-26.787-9.874-51.029-31.487-18.86-16.827-31.597-37.598-35.297-43.955-3.702-6.355-.39-9.789 2.775-12.943 2.849-2.848 6.344-7.414 9.522-11.116s4.225-6.355 6.343-10.581c2.12-4.238 1.06-7.937-.522-11.117-1.584-3.177-14.271-34.409-19.568-47.108-5.151-12.37-10.385-10.69-14.269-10.897-3.703-.183-7.927-.219-12.164-.219s-11.105 1.582-16.925 7.939c-5.82 6.354-22.209 21.709-22.209 52.927 0 31.22 22.733 61.405 25.911 65.642 3.177 4.237 44.745 68.318 108.389 95.812 15.135 6.538 26.957 10.446 36.175 13.368 15.196 4.834 29.027 4.153 39.96 2.52 12.19-1.825 37.54-15.353 42.824-30.172 5.283-14.818 5.283-27.529 3.701-30.172-1.582-2.641-5.819-4.237-12.163-7.414l.011-.024z"/>
// </svg>

// )


// // import pin from "../../assets/pin.png";

// const phone=(      
//     <svg
//         xmlns="http://www.w3.org/2000/svg"
//         width="32"
//         height="32"
//         viewBox="0 0 24 24"
//         fill="none"
//         stroke="currentColor"
//         strokeWidth="2"
//         strokeLinecap="round"
//         strokeLinejoin="round"
//         className="lucide lucide-phone-call"
//       >
//         <path d="M13 2a9 9 0 0 1 9 9" />
//         <path d="M13 6a5 5 0 0 1 5 5" />
//         <path d="M13.832 16.568a1 1 0 0 0 1.213-.303l.355-.465A2 2 0 0 1 17 15h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2A18 18 0 0 1 2 4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-.8 1.6l-.468.351a1 1 0 0 0-.292 1.233 14 14 0 0 0 6.392 6.384" />
//       </svg>
//       )
// const email=(    
//     <svg
//       xmlns="http://www.w3.org/2000/svg"
//       width="32"
//       height="32"
//       viewBox="0 0 24 24"
//       fill="none"
//       stroke="currentColor"
//       strokeWidth="2"
//       strokeLinecap="round"
//       strokeLinejoin="round"
//       className="lucide lucide-mail"
//     >
//       <path d="m22 7-8.991 5.727a2 2 0 0 1-2.009 0L2 7" />
//       <rect x="2" y="4" width="20" height="16" rx="2" />
//     </svg>
//     )


function CommunicationItem({type,display,ItemPostId,ItemUserId}) {

  const getIcon = () => {
    switch (type) {
      case "whatsapp":
        return <WhatsappIcon size={24} />;        
      case "phone":
        return <PhoneIcon size={24} />;
      case "email":
        return <EmailIcon size={24} />;

      default:
        return "🔗";
    }
  };
 const getLabel = () => {
    switch (type) {
      case "whatsapp":
        return "WhatsApp";
      case "phone":
        return "Call";
      case "email":
        return "Email";
      default:
        return "Contact";
    }
  };

const handleContactClick = async () => {
    console.log("type: ",type)
    console.log("display: ",display)
    console.log("ItemUserId: ",ItemUserId)
    console.log("ItemPostId: ",ItemPostId)
    
    try {
      // Update count in backend
      console.log("no calling communication")
      await apiRequest.post(`/posts/communication`, {
        postid: ItemPostId,
        userid: ItemUserId,
        type,
      });
    } catch (err) {
      console.error("Failed to update communication log", err);
    }

    // Open actual communication channel
    if (type === "phone") {
      window.location.href = `tel:${display}`;
    } else if (type === "whatsapp") {
      window.open(`https://wa.me/${display}`, "_blank");
    } else if (type === "email") {
      window.location.href = `mailto:${display}`;
    }
  };

    return (
      <div className="CommItem">
        <div className="btnContent" onClick={() => handleContactClick()} aria-label={`${getLabel()} ${display}`}>
          <div className="btnIcon">{getIcon()}</div>
          <div className="btnDisplay">{display}</div>
        </div>
</div>
  )
}

export default CommunicationItem